// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/.pnpm/css-loader@7.1.2_@rspack+core@2.3.1_@swc+helpers@0.5.23__webpack@5.104.1_@swc+core@1.15_5c916327c7a1e0ea96b4ad86b04a02b8/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/.pnpm/css-loader@7.1.2_@rspack+core@2.3.1_@swc+helpers@0.5.23__webpack@5.104.1_@swc+core@1.15_5c916327c7a1e0ea96b4ad86b04a02b8/node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_ICSS_IMPORT_0___ from "-!../../../../../node_modules/.pnpm/css-loader@7.1.2_@rspack+core@2.3.1_@swc+helpers@0.5.23__webpack@5.104.1_@swc+core@1.15_5c916327c7a1e0ea96b4ad86b04a02b8/node_modules/css-loader/dist/cjs.js??ruleSet[1].rules[2].oneOf[0].use[1]!./base.module.css";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_ICSS_IMPORT_0___, "", true);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.MaLmiTCQn4QMQHd6 {
	font: var(--lp-text-body-2-regular);
	color: var(--lp-color-text-ui-primary-base);
	padding: 5px var(--lp-spacing-300);
	border-radius: var(--lp-border-radius-medium);
	border-width: var(--lp-border-width-200);
	border-style: solid;
	flex: 1;
	min-width: 0;

	&:is([data-focused], [data-focus-within]) {
		outline: 2px solid var(--lp-color-shadow-interactive-focus);
		outline-offset: -2px;
		z-index: 1;
	}

	&[data-disabled] {
		color: var(--lp-color-text-field-disabled);
		background-color: var(--lp-color-bg-field-disabled);
		border-color: var(--lp-color-bg-field-disabled);
	}

	&[data-invalid] {
		border-color: var(--lp-color-border-field-error);
	}

	&::placeholder {
		color: var(--lp-color-text-field-placeholder);
	}
}

.clnbDLk7QTsGVXYZ {
	position: relative;
	display: flex;
	flex: 1;
	min-width: 0;

	&:has(> [data-validation-icon]) > input {
		padding-inline-end: var(--lp-spacing-700);
	}
}

.Q2F4Fm8ZU6PRhi9G {
	position: absolute;
	top: 50%;
	inset-inline-end: var(--lp-spacing-300);
	z-index: 2;
	fill: var(--lp-color-fill-feedback-success);
	pointer-events: none;
	transform: translateY(-50%);
}

.AcxGLpXu7b0c3eFD {
	border-color: var(--lp-color-border-field-base);
	background-color: var(--lp-color-bg-field-base);
}

.yFpJBOMXadwuDUws {
	background-color: inherit;
	margin-left: calc(-1 * var(--lp-spacing-300) - 1px);

	&:not([data-invalid]) {
		border-color: transparent;
	}

	&[data-hovered]:not([data-focused]):not([data-focus-within]) {
		background-color: var(--lp-color-bg-interactive-secondary-hover);
	}
}
`, "",{"version":3,"sources":["webpack://./../../launchpad-ui/packages/components/src/styles/Input.module.css"],"names":[],"mappings":"AAAA;CAEC,mCAAmC;CACnC,2CAA2C;CAC3C,kCAAkC;CAClC,6CAA6C;CAC7C,wCAAwC;CACxC,mBAAmB;CACnB,OAAO;CACP,YAAY;;CAEZ;EACC,2DAA2D;EAC3D,oBAAoB;EACpB,UAAU;CACX;;CAEA;EACC,0CAA0C;EAC1C,mDAAmD;EACnD,+CAA+C;CAChD;;CAEA;EACC,gDAAgD;CACjD;;CAEA;EACC,6CAA6C;CAC9C;AACD;;AAEA;CACC,kBAAkB;CAClB,aAAa;CACb,OAAO;CACP,YAAY;;CAEZ;EACC,yCAAyC;CAC1C;AACD;;AAEA;CACC,kBAAkB;CAClB,QAAQ;CACR,uCAAuC;CACvC,UAAU;CACV,2CAA2C;CAC3C,oBAAoB;CACpB,2BAA2B;AAC5B;;AAEA;CACC,+CAA+C;CAC/C,+CAA+C;AAChD;;AAEA;CACC,yBAAyB;CACzB,mDAAmD;;CAEnD;EACC,yBAAyB;CAC1B;;CAEA;EACC,gEAAgE;CACjE;AACD","sourcesContent":[".base {\n\tcomposes: field from './base.module.css';\n\tfont: var(--lp-text-body-2-regular);\n\tcolor: var(--lp-color-text-ui-primary-base);\n\tpadding: 5px var(--lp-spacing-300);\n\tborder-radius: var(--lp-border-radius-medium);\n\tborder-width: var(--lp-border-width-200);\n\tborder-style: solid;\n\tflex: 1;\n\tmin-width: 0;\n\n\t&:is([data-focused], [data-focus-within]) {\n\t\toutline: 2px solid var(--lp-color-shadow-interactive-focus);\n\t\toutline-offset: -2px;\n\t\tz-index: 1;\n\t}\n\n\t&[data-disabled] {\n\t\tcolor: var(--lp-color-text-field-disabled);\n\t\tbackground-color: var(--lp-color-bg-field-disabled);\n\t\tborder-color: var(--lp-color-bg-field-disabled);\n\t}\n\n\t&[data-invalid] {\n\t\tborder-color: var(--lp-color-border-field-error);\n\t}\n\n\t&::placeholder {\n\t\tcolor: var(--lp-color-text-field-placeholder);\n\t}\n}\n\n.validInput {\n\tposition: relative;\n\tdisplay: flex;\n\tflex: 1;\n\tmin-width: 0;\n\n\t&:has(> [data-validation-icon]) > input {\n\t\tpadding-inline-end: var(--lp-spacing-700);\n\t}\n}\n\n.validIcon {\n\tposition: absolute;\n\ttop: 50%;\n\tinset-inline-end: var(--lp-spacing-300);\n\tz-index: 2;\n\tfill: var(--lp-color-fill-feedback-success);\n\tpointer-events: none;\n\ttransform: translateY(-50%);\n}\n\n._default {\n\tborder-color: var(--lp-color-border-field-base);\n\tbackground-color: var(--lp-color-bg-field-base);\n}\n\n.minimal {\n\tbackground-color: inherit;\n\tmargin-left: calc(-1 * var(--lp-spacing-300) - 1px);\n\n\t&:not([data-invalid]) {\n\t\tborder-color: transparent;\n\t}\n\n\t&[data-hovered]:not([data-focused]):not([data-focus-within]) {\n\t\tbackground-color: var(--lp-color-bg-interactive-secondary-hover);\n\t}\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"base": `MaLmiTCQn4QMQHd6 ${___CSS_LOADER_ICSS_IMPORT_0___.locals["field"]}`,
	"validInput": `clnbDLk7QTsGVXYZ`,
	"validIcon": `Q2F4Fm8ZU6PRhi9G`,
	"_default": `AcxGLpXu7b0c3eFD`,
	"minimal": `yFpJBOMXadwuDUws`
};
export default ___CSS_LOADER_EXPORT___;
